!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Transposit = t() : e.Transposit = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    n.r(t);

    var _r,
        o = (_r = function r(e, t) {
      return (_r = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        i = function (e) {
      function t(n) {
        var r = e.call(this, n) || this;
        return r.name = "SDKError", Object.setPrototypeOf(r, t.prototype), r;
      }

      return o(t, e), t;
    }(Error),
        u = function () {
      var _e = function e(t, n) {
        return (_e = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function r() {
          this.constructor = t;
        }

        _e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }(),
        a = function (e) {
      function t(n, r) {
        var o = e.call(this, n) || this;
        return o.name = "APIError", o.response = r, Object.setPrototypeOf(o, t.prototype), o;
      }

      return u(t, e), t;
    }(i),
        c = function () {
      var _e2 = function e(t, n) {
        return (_e2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(t, n);
      };

      return function (t, n) {
        function r() {
          this.constructor = t;
        }

        _e2(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }(),
        s = function (e) {
      function t(n, r) {
        var o,
            i = this,
            u = n.result.exceptionLog;
        return o = u && u.message ? u.message : "A problem occurred when processing this operation.", (i = e.call(this, o, r) || this).requestId = n.requestId, Object.setPrototypeOf(i, t.prototype), i;
      }

      return c(t, e), t;
    }(a),
        l = function l(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function u(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function a(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(u, a);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        f = function f(e, t) {
      var n,
          r,
          o,
          i,
          u = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function a(i) {
        return function (a) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; u;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return u.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    u.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = u.ops.pop(), u.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = u.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      u = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      u.label = i[1];
                      break;
                    }

                    if (6 === i[0] && u.label < o[1]) {
                      u.label = o[1], o = i;
                      break;
                    }

                    if (o && u.label < o[2]) {
                      u.label = o[2], u.ops.push(i);
                      break;
                    }

                    o[2] && u.ops.pop(), u.trys.pop();
                    continue;
                }

                i = t.call(e, u);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, a]);
        };
      }
    },
        p = "TRANPOSIT_PKCE";

    function d(e) {
      return btoa(String.fromCharCode.apply(null, new Uint8Array(e))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    }

    function h(e) {
      return l(this, void 0, void 0, function () {
        return f(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, (n = e, r = new TextEncoder().encode(n), window.crypto.subtle.digest("SHA-256", r))];

            case 1:
              return [2, d(t.sent())];
          }

          var n, r;
        });
      });
    }

    function y() {
      return l(this, void 0, void 0, function () {
        var e;
        return f(this, function (t) {
          switch (t.label) {
            case 0:
              return n = new Uint32Array(28), window.crypto.getRandomValues(n), e = Array.from(n, function (e) {
                return ("0" + e.toString(16)).substr(-2);
              }).join(""), localStorage.setItem(p, e), [4, h(e)];

            case 1:
              return [2, t.sent()];
          }

          var n;
        });
      });
    }

    var b = "TRANSPOSIT_ACCESS_TOKEN";

    function w(e) {
      var t = null;

      try {
        t = function (e) {
          return JSON.parse(atob(e.split(".")[1]));
        }(e);
      } catch (e) {
        return !1;
      }

      return function (e) {
        return 1e3 * e.exp > Date.now();
      }(t);
    }

    function v(e) {
      return Object.keys(e).map(function (t) {
        return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
      }).join("&");
    }

    var g = function g(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function u(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function a(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(u, a);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        m = function m(e, t) {
      var n,
          r,
          o,
          i,
          u = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function a(i) {
        return function (a) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; u;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return u.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    u.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = u.ops.pop(), u.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = u.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      u = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      u.label = i[1];
                      break;
                    }

                    if (6 === i[0] && u.label < o[1]) {
                      u.label = o[1], o = i;
                      break;
                    }

                    if (o && u.label < o[2]) {
                      u.label = o[2], u.ops.push(i);
                      break;
                    }

                    o[2] && u.ops.pop(), u.trys.pop();
                    continue;
                }

                i = t.call(e, u);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, a]);
        };
      }
    };

    function _(e, t) {
      return g(this, void 0, void 0, function () {
        var n, r, o;
        return m(this, function (i) {
          switch (i.label) {
            case 0:
              return [4, fetch(e, t)];

            case 1:
              return (n = i.sent()).ok ? [2, n] : [3, 2];

            case 2:
              r = void 0, i.label = 3;

            case 3:
              return i.trys.push([3, 5,, 6]), [4, n.json()];

            case 4:
              return o = i.sent(), r = "string" == typeof o.message ? new a(o.message, n) : S(n), [3, 6];

            case 5:
              return i.sent(), r = S(n), [3, 6];

            case 6:
              throw r;
          }
        });
      });
    }

    var O = "API call failed in an unexpected way. Try again.";

    function S(e) {
      return new a(O, e);
    }

    var k = function k(e, t, n, r) {
      return new (n || (n = Promise))(function (o, i) {
        function u(e) {
          try {
            c(r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function a(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(u, a);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        x = function x(e, t) {
      var n,
          r,
          o,
          i,
          u = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function a(i) {
        return function (a) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; u;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return u.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    u.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = u.ops.pop(), u.trys.pop();
                    continue;

                  default:
                    if (!(o = (o = u.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      u = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      u.label = i[1];
                      break;
                    }

                    if (6 === i[0] && u.label < o[1]) {
                      u.label = o[1], o = i;
                      break;
                    }

                    if (o && u.label < o[2]) {
                      u.label = o[2], u.ops.push(i);
                      break;
                    }

                    o[2] && u.ops.pop(), u.trys.pop();
                    continue;
                }

                i = t.call(e, u);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, a]);
        };
      }
    },
        P = function () {
      function e(e) {
        void 0 === e && (e = ""), this.hostedAppOrigin = e.replace(/\/$/, ""), this.accessToken = null, this.load();
      }

      return e.prototype.uri = function (e) {
        return void 0 === e && (e = ""), "" + this.hostedAppOrigin + e;
      }, e.prototype.load = function () {
        var e;
        this.accessToken = (e = localStorage.getItem(b)) && w(e) ? e : null;
      }, e.prototype.assertIsSignedIn = function () {
        if (!this.accessToken) throw new i("This method can only be called if the user is signed in");
      }, e.prototype.isSignedIn = function () {
        return null !== this.accessToken;
      }, e.prototype.signIn = function (e, t) {
        return k(this, void 0, void 0, function () {
          var n, r;
          return x(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, y()];

              case 1:
                return n = o.sent(), (r = new URLSearchParams()).append("scope", "openid app"), r.append("response_type", "code"), r.append("client_id", "sdk"), r.append("redirect_uri", e), r.append("prompt", "login"), r.append("code_challenge", n), r.append("code_challenge_method", "S256"), t && r.append("provider", t), window.location.href = this.uri("/login/authorize?" + r.toString()), [2];
            }
          });
        });
      }, e.prototype.handleSignIn = function () {
        return k(this, void 0, void 0, function () {
          var e, t, n, r, o, u;
          return x(this, function (a) {
            switch (a.label) {
              case 0:
                if (!(e = new URLSearchParams(window.location.search)).has("code")) throw new i("code query parameter could not be found. This method should only be called after redirection during sign-in.");
                return t = e.get("code"), n = function () {
                  var e = localStorage.getItem(p);
                  if (!e) throw new i("PKCE state could not be found.");
                  return localStorage.removeItem(p), e;
                }(), r = {
                  "Content-Type": "application/x-www-form-urlencoded"
                }, o = {
                  grant_type: "authorization_code",
                  code: t,
                  redirect_uri: "" + window.location.origin + window.location.pathname,
                  code_verifier: n
                }, [4, this.makeCallJson("POST", "/login/authorize/token", {
                  headers: r,
                  body: o
                })];

              case 1:
                return u = a.sent(), c = u.access_token, localStorage.setItem(b, c), this.accessToken = u.access_token, [2, {
                  needsKeys: u.needs_keys
                }];
            }

            var c;
          });
        });
      }, e.prototype.signOut = function (e) {
        this.accessToken = null, localStorage.removeItem(b), window.location.href = this.uri("/logout?redirectUri=" + encodeURIComponent(e));
      }, e.prototype.settingsUri = function (e) {
        return this.uri("/settings?redirectUri=" + encodeURIComponent(e || window.location.href));
      }, e.prototype.loadUser = function () {
        return k(this, void 0, void 0, function () {
          return x(this, function (e) {
            switch (e.label) {
              case 0:
                return this.assertIsSignedIn(), [4, this.makeCallJson("GET", "/api/v1/user")];

              case 1:
                return [2, e.sent()];
            }
          });
        });
      }, e.prototype.run = function (e, t) {
        return void 0 === t && (t = {}), k(this, void 0, void 0, function () {
          var n, r;
          return x(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.makeCall("POST", "/api/v1/execute/" + e, {
                  body: {
                    parameters: t
                  }
                })];

              case 1:
                return [4, T(n = o.sent())];

              case 2:
                if ("SUCCESS" !== (r = o.sent()).status) throw new s(r, n);
                return [2, new j(r, n)];
            }
          });
        });
      }, e.prototype.makeCallJson = function (e, t, n) {
        return void 0 === n && (n = {}), k(this, void 0, void 0, function () {
          return x(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.makeCall(e, t, n)];

              case 1:
                return [2, T(r.sent())];
            }
          });
        });
      }, e.prototype.makeCall = function (e, t, n) {
        var r = void 0 === n ? {} : n,
            o = r.queryParams,
            i = r.body,
            u = r.headers;
        return k(this, void 0, void 0, function () {
          var n, r;
          return x(this, function (a) {
            switch (a.label) {
              case 0:
                return u || (u = {
                  "Content-Type": "application/json"
                }, this.accessToken && (u.Authorization = "Bearer " + this.accessToken)), n = new URL(t, this.hostedAppOrigin), null != o && Object.keys(o).forEach(function (e) {
                  return n.searchParams.append(e, o[e]);
                }), r = "application/x-www-form-urlencoded" === u["Content-Type"] ? v : JSON.stringify, [4, _(n.href, Object.assign({
                  method: e,
                  headers: u
                }, null === i ? null : {
                  body: r(i)
                }))];

              case 1:
                return [2, a.sent()];
            }
          });
        });
      }, e;
    }();

    function T(e) {
      return e.json().then(function (e) {
        return e;
      }, function () {
        throw new a("Failed to read response body", e);
      });
    }

    var j = function () {
      function e(e, t) {
        this.requestId = e.requestId;
        var n = e.result.results;
        if (!n) throw new a("API returned an unexpected response schema", t);
        this.results = n;
      }

      return Object.defineProperty(e.prototype, "value", {
        get: function get() {
          if (0 === this.results.length) throw new Error("Operation did not return a value");
          return this.results[0];
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    n.d(t, "OperationError", function () {
      return s;
    }), n.d(t, "Transposit", function () {
      return P;
    });
  }]);
});